import HttpStatusError from "./http-status-error";

export const sendTextPostRequestToServer = async (url, body) => {
  let bodyJson = typeof body === "string" ? body : JSON.stringify(body);
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Length": bodyJson.length
    },
    body: bodyJson
  }).then(res => {
    if (res.ok) {
      return res.text();
    }
    return new HttpStatusError(res.status);
  });
};

export const sendJsonPostRequestToServer = async (url, body) => {
  let bodyJson = typeof body === "string" ? body : JSON.stringify(body);
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Length": bodyJson.length,
      "Content-Type": "application/json"
      //Accept: "application/json"
    },
    body: bodyJson
  }).then(res => {
    if (res.ok) {
      return res.json();
    }
    return new HttpStatusError(res.status);
  });
};
